import { render } from "./MenuBarMiddle.vue?vue&type=template&id=30c57f76"
import script from "./MenuBarMiddle.vue?vue&type=script&lang=js"
export * from "./MenuBarMiddle.vue?vue&type=script&lang=js"

import "./MenuBarMiddle.vue?vue&type=style&index=0&id=30c57f76&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__